import { useEffect } from 'react'
import { useAppSelector } from '../redux/hooks'
import useBankAccountActions from './useBankAccountActions'

// Fetches the employer bank accounts of a market once and shares them between every consumer on the page,
// so the credit facility details view and the edit form do not each request the same list.
const useMarketBankAccounts = (marketId?: string) => {
  const { getBankAccounts } = useBankAccountActions()

  const bankAccounts = useAppSelector(state => state.bankAccount.bankAccounts)
  const loadedMarketId = useAppSelector(state => state.bankAccount.marketId)
  const loading = useAppSelector(state => state.bankAccount.loading)

  useEffect(() => {
    if (marketId && marketId !== loadedMarketId && !loading)
      getBankAccounts(marketId)
  }, [marketId, loadedMarketId, loading])

  return marketId === loadedMarketId ? bankAccounts : []
}

export default useMarketBankAccounts
